module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "h-full"
  }, [_c('div', {
    staticClass: "acompanhamento-lance2 h-full",
    class: {
      'isLoading': _vm.isLoading,
      isOnline: _vm.apelido !== 'PLATEIA' && _vm.apelido !== '-'
    }
  }, [_c('div', {
    staticClass: "box valorAtual",
    class: {
      novoLance: _vm.hasNovoLance
    }
  }, [_vm._v(_vm._s(_vm._f("moeda")(_vm.valor)))]), _vm._v(" "), (_vm.apelido !== '-') ? _c('div', {
    staticClass: "tipoLance"
  }, [(_vm.apelido !== 'PLATEIA') ? _c('span', [_vm._v("Online")]) : _c('span', [_vm._v("Presencial")])]) : _c('div', {
    staticClass: "tipoLance"
  }, [_c('span', [_vm._v("-")])]), _vm._v(" "), _c('div', {
    staticClass: "box-lance"
  }, [_c('div', {
    staticClass: "lance"
  }, [_c('div', {
    staticClass: "apelido"
  }, [_vm._v(_vm._s(_vm.apelido))]), _vm._v(" "), _c('div', {
    staticClass: "localidade"
  }, [_vm._v(_vm._s(_vm.lanceLocalidade))])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2539b9e2","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/website/pregao-lance2/Main.vue
// module id = 1742
// module chunks = 18